import { render } from "./IconMenuManegmentListComponent.vue?vue&type=template&id=587a4674&scoped=true&ts=true"
import script from "./IconMenuManegmentListComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuManegmentListComponent.vue?vue&type=script&lang=ts"

import "./IconMenuManegmentListComponent.vue?vue&type=style&index=0&id=587a4674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a4674"]])

export default __exports__